<template>
  <v-list-item
    two-line
    dense
    class="primary white--text"
    v-if="Object.values(Cliente.data) != 0"
  >
    <v-list-item-content>
      <v-list-item-title class="text-subtitle-1">
        {{ Cliente.data ? Cliente.data.Nombre : "" }}</v-list-item-title
      >
      <v-list-item-subtitle class="text-subtitle-2 white--text">
        {{ Cliente.data ? Cliente.data.Codigo : "" }}</v-list-item-subtitle
      >
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["Cliente"]),
  },
};
</script>

<style></style>
